export default __webpack_public_path__ + "static/media/arena_digital.79cd4685.png";